import React from "react";
import BlockContent from '@sanity/block-content-to-react';
import { generateImageUrl } from "../../sanityConfig";
const BlogPostContent = ({ blogPost }) => {
    const serializers = {
        types: {
            horizontalLine: () => (
                <hr />
            ),
            quote: (props) => {
                return (
                    <blockquote><p><em>“{props?.node?.quote}”</em></p><cite>– {props?.node?.quoteBy}</cite></blockquote>
                )
            },
            htmlCode: (props) => {
                return (
                    <div className="code-block" dangerouslySetInnerHTML={{ __html: props.node.code }} />
                )
            },
            images: (props) => {
                return (
                    <div>
                        <div className="flex justify-between flex-wrap">
                            {
                                props.node.captionImages.map((image, index) => {
                                    return (
                                        <div key={index} className={` ${index === 0 ? "w-full first-image" : "w-full md:w-48Percent h-96"}  mb-4 single-image bg-cover bg-no-repeat flex items-end justify-center`} style={{ backgroundImage: "url(" + generateImageUrl(image?.image?.asset).url() + ")" }} >
                                            <p className="pb-4 text-white">{image?.caption}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                )
            }
        },
    }
    return (
        <div className="blog-post-content">
            <BlockContent blocks={blogPost.content} serializers={serializers} />
        </div>
    )
}
export default BlogPostContent;